(() => {
  'use strict';
  const init = () => {
    if (!document.body.classList.contains('template-index')) return;
    if (document.body.dataset.homeCtaReady === 'true') return;
    const hero = document.querySelector('.gold-home__hero');
    if (!hero) return;
    document.body.dataset.homeCtaReady = 'true';
    document.body.classList.add('home-cta-enhanced');
    let frame = 0;
    const update = () => {
      const belowHero = hero.getBoundingClientRect().bottom <= 110;
      document.body.classList.toggle('home-cta-sticky-visible', belowHero);
    };
    const queueUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        update();
      });
    };
    window.addEventListener('scroll', queueUpdate, {passive:true});
    window.addEventListener('resize', queueUpdate, {passive:true});
    window.addEventListener('pageshow', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', () => {
    if (document.body.dataset.homeCtaReady !== 'true') init();
  });
})();